import { initializeApp } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, getDocs, collection, onSnapshot, addDoc } from "firebase/firestore";
import { watch } from "vue";

import { firebaseConfig } from "/src/firebaseConfig.js";
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const USERS_COLLECTION = "users";
const EVENTS_COLLECTION = "events";

export async function authenticateWithCustomToken(token) {
    return await signInWithCustomToken(auth, token);
}

export async function saveUserProfile(user, data) {
    const ref = doc(db, USERS_COLLECTION, user.uid);
    await setDoc(ref, data, { merge: true });
}

export async function getUserProfileById(userId){
    const ref = doc(db, "users", userId)
    const docSnap = await getDoc(ref)
    if (docSnap.exists()){
        return docSnap.data();
    }
    return null;
}

export async function getOrCreateUserProfile(user) {
    const ref = doc(db, "users", user.steamid);
    const docSnap = await getDoc(ref);
    if (docSnap.exists()) {
        return docSnap.data();
    } else {
        const newProfile = {
            events: [],
            nickname: user.username || "NewUser",
            avatarUrl: user.avatar?.large || "",
        };
        await setDoc(ref, newProfile);
        return newProfile;
    }
}

export async function setUserEventsFirebase(userId, events) {
    const ref = doc(db, "users", userId);
    await setDoc(ref, { events: events }, { merge: true });
}

export async function subscribeToProfile(callback){
    const profileCollection = collection(db, "users");
    const unsubscribe = onSnapshot(profileCollection, (snapshot) => {
        const profiles = [];
        snapshot.forEach((doc) => {
            profiles.push({ id: doc.id, ...doc.data() });
            
        });
        callback(profiles);
    });

    return unsubscribe;
}

export async function subscribeToEvents(callback) {
    // Subscribe to Firestore collection and invoke callback on updates
    // Return the unsubscribe function to allow caller to stop listening
    const eventsCollection = collection(db, "events");
    const unsubscribe = onSnapshot(eventsCollection, (snapshot) => {
        const events = [];
        snapshot.forEach((doc) => {
            events.push({ id: doc.id, ...doc.data() });
        });
        callback(events);
    });

    return unsubscribe;
}

const tempLayout = [ // This should not be here in the long run, I just keep it here since we havnt set up proper event creation yet
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
    { row: ["", "", "space", "", ""] },
];


export async function updateSeatBooking(eventId, spotId, uid, originalSpotId) {
    const eventRef = doc(db, "events", eventId);
    const eventSnap = await getDoc(eventRef);
    if (eventSnap.exists()) {

        const eventData = eventSnap.data();
        const spots = eventData.spots || tempLayout;

        if (spotId !== null && spotId[0] !== null && spots[spotId[0]].row[spotId[1]] !== undefined) {
            spots[spotId[0]].row[spotId[1]] = uid;
        }

        if (originalSpotId[0] !== null && originalSpotId[1] !== null) {
            spots[originalSpotId[0]].row[originalSpotId[1]] = "";
        }

        await setDoc(eventRef, { spots: spots }, { merge: true });
    } else {
        console.error("Event ID not found");
    }
}

export async function addUserToInterest(eventId, interest, userID) {
    const eventRef = doc(db, "events", eventId);
    const eventSnap = await getDoc(eventRef);
    if (eventSnap.exists()) {
        const eventData = eventSnap.data();
        const interests = eventData.interests || [];

        const existingInterest = interests.find(i => i.id === interest.id);

        if (!existingInterest) {
            // Create new interest if it doesn't exist
            const newInterest = { name: interest.name, id: interest.id, imageURL: interest.imageURL, users: [userID] };
            interests.push(newInterest);
            await setDoc(eventRef, { interests: interests }, { merge: true });
            return;
        }
        if (!existingInterest.users.includes(userID)) {
            existingInterest.users.push(userID);
            await setDoc(eventRef, { interests: interests }, { merge: true });
        }
    } else {
        console.error("Event ID not found");
    }
}

export async function removeUserFromInterest(eventId, interestIds, userId) {
    const eventRef = doc(db, "events", eventId);
    const eventSnap = await getDoc(eventRef);
    if (eventSnap.exists()) {
        const eventData = eventSnap.data();
        const interests = eventData.interests || [];
        for (const interestId of interestIds) {
            const existingInterest = interests.find(i => i.id === interestId);

            if (existingInterest) {
                const userIndex = existingInterest.users.indexOf(userId);
                if (userIndex !== -1) {
                    existingInterest.users.splice(userIndex, 1);
                    // Also need to remove the interest if no users are left
                    if (existingInterest.users.length === 0) {
                        interests.splice(interests.indexOf(existingInterest), 1);
                    }

                }
            }
        }
        await setDoc(eventRef, { interests: interests }, { merge: true });
    } else {
        console.error("Event ID not found");
    }
}


export async function addEvent(newEvent) {
    try {
        const eventsCollection = collection(db, "events");

        if(!newEvent.spots){
            newEvent.spots = tempLayout;
        }

        if (newEvent.imageUrl == null) {
            // Handle image upload if needed
            newEvent.imageUrl = "https://www.hellovalencia.es/wp-content/uploads/2022/12/DreamHack-scaled.jpg"; // Placeholder image URL
        }

        const ref = await addDoc(eventsCollection, newEvent);
        return true;
    } catch (e) {
        console.error("Error adding event: ", e);
        return false;
    }
}
